import { authApi } from "shared/api/authApi";

export const verifyOtpRequest = (payload) => {
  return authApi.verifyOtp(payload);
};
